export const pl = {
    // Tłumaczenia na język włoski:
    required: '* Pole obowiązkowe',
    validation: {
        required: controlName => `Proszę wprowadzić ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        minmaxNotLessThen: (controlName, min) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} nie może być mniejsze niż ${min}`,
        minmaxNotGreaterThen: (controlName, max) => `${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()} nie może być większe niż ${max}`,
    },
    switch: {
        yes: 'Tak',
        no: 'Nie',
    },
    dateRange: {
        arrival: 'Przyjazd',
        departure: 'Wyjazd',
    },
    travelData: {
        title: 'Wprowadź dane swojego urlopu i otrzymuj spersonalizowane oferty e-mailowo, bezpośrednio od obiektów.',
        range: 'data przyjazdu i wyjazdu',
        hasPets: 'Zwierzęta',
        petsMessage: 'opis zwierząt',
        petsMessagePlaceholder: "np. 1 duży pies (ok. 10 kg), 2 koty...",
        boards: 'Pensja',
        rooms: {
            validation: {
                roomsMissing: 'Wprowadź co najmniej 1 pokój',
                adultsMissing: 'Wprowadź liczbę dorosłych',
                roomsWithoutAdults: 'Wprowadź co najmniej 1 dorosłego na pokój',
                childAgeMissing: 'Wprowadź wiek dzieci',
            },
            adults: 'Dorośli',
            children: 'Dzieci',
            rooms: 'Pokoje',
            age: 'Wiek',
            room: 'Pokój/mieszkanie',
            roomInfo: 'Informacje dotyczące pokoju, mieszkania, miejsca itp.',
            removeRoom: 'Usuń pokój/mieszkanie',
            addRoom: 'Dodaj pokój/mieszkanie',
            childrenAges: 'Wiek dzieci',
            years: age => `${age} ${age == 1 ? 'rok' : age >= 2 && age <= 4 ? 'lata' : 'lat'}`,
            done: 'Gotowe',
        },
        submit: 'Kontynuuj',
    },
    filter: {
        title: 'Wybierz rodzaj zakwaterowania i preferowaną region i odkryj obiekty spełniające Twoje oczekiwania!',
        accotypesValidatorText: controlName => `Wybierz ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        areaValidatorText: controlName => `Wybierz ${controlName === null || controlName === void 0 ? void 0 : controlName.toLowerCase()}`,
        maxCountValidatorText: (controlName, max) => `Możesz wybrać maksymalnie ${max} zakwaterowań.\nUżyj innych filtrów.`,
        accotypesAndBoards: 'Rodzaj zakwaterowania i pensja',
        boards: 'Pensja',
        accotypes: 'Rodzaj zakwaterowania',
        areas: 'Regiony i lokalizacje',
        resorts: 'Lokalizacje',
        regions: 'Regiony',
        selectAllRegions: 'Wybierz wszystkie regiony Południowego Tyrolu',
        searchAreas: 'Wyszukaj regiony i lokalizacje...',
        themesAmeneties: 'Udogodnienia / Rodzaj wakacji',
        ameneties: 'Udogodnienia',
        themes: 'Rodzaj wakacji',
        overlay: {
            accosText: count => `<b>${count}</b> ${count == 1 ? "zakwaterowanie" : "zakwaterowania"} wybrane`,
            done: 'Gotowe',
        },
        back: 'Powrót',
        submitContinueWith: 'Kontynuuj z',
        submitAccosText: count => `${count} ${count == 1 ? "zakwaterowanie" : "zakwaterowania"}`,
    },
    accos: {
        title: 'Przegląd zakwaterowania',
        subtitle: (selected, count) => `Wyślij zapytanie do ${selected} ${selected == 1 ? "obiektu" : "obiektów"} lub wybierz określony obiekt`,
        back: 'Powrót',
        submitContinueWith: 'Kontynuuj z',
        submitAccosText: count => `${count} ${count == 1 ? "zakwaterowanie" : "zakwaterowania"}`,
    },
    personalData: {
        accosCount: count => `<b>${count}</b> ${count == 1 ? "zakwaterowanie" : "zakwaterowania"}`,
        adults: count => `<b>${count}</b> ${count == 1 ? 'Dorosły' : 'Dorośli'}`,
        children: count => `<b>${count}</b> ${count == 1 ? 'Dziecko' : 'Dzieci'}`,
        rooms: count => `<b>${count}</b> ${count == 1 ? 'Pokój' : 'Pokój'}`,
        pets: 'Pet/s',
        accotypes: count => `${count == 1 ? 'Typ zakwaterowania:' : 'Rodzaje zakwaterowania:'}`,
        areas: count => `${count == 1 ? `Region/lokalizacja:` : `Regiony/miejsca:`}`,

        title: 'Wprowadź swoje dane, aby otrzymywać spersonalizowane oferty bezpośrednio od obiektów!',
        email: 'E-mail',
        salutation: 'Forma grzecznościowa',
        salutationOptions: {
            herr: 'Pan',
            frau: 'Pani',
            familie: 'Rodzina',
            firma: 'Firma',
        },
        firstname: 'Imię',
        lastname: 'Nazwisko',
        phone: 'Telefon',
        message: 'Uwagi i pytania',
        privacy: privacyUrl => `Tak, wyrażam zgodę na <a href="${privacyUrl}" target="_blank">przetwarzanie moich danych osobowych</a>.`,
        privacyRequired: 'Zgoda na przetwarzanie danych',
        newsletter: 'Tak, chcę otrzymywać newsletter od alto-adige.com',
        newsletterNote: 'Nasz darmowy newsletter jest regularnie wysyłany raz w miesiącu i zawiera najlepsze oferty na wakacje w Południowym Tyrolu oraz przydatne wskazówki od redakcji. Możesz się wypisać w dowolnym momencie.',
        generalError: 'Wystąpił problem. Proszę spróbować ponownie później.',
        back: 'Powrót',
        submit: count => `Wyślij zapytanie`,
    },
    thankyou: {
        title: 'Zapytanie złożone pomyślnie',
        successText: 'Zapytanie zostało pomyślnie wysłane',
    },
};
//# sourceMappingURL=Enquiry.i18n.pl.js.map